import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Contact from "../Contact";
import Banner from "./Banner";
import LatestNews from "./LatestNews";
import ProjectService from "./ProjectService";

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Banner />
      <ProjectService />
      <LatestNews />
      <Contact header={false} />
    </Box>
  );
};

export default Home;
